import authenticationConstants from 'components/Authentication/constants';
import { NOT_SURE_ANSWERED_QUESTIONS_STORAGE_KEY } from './intake.constants';

const { LOGOUT } = authenticationConstants;

export const intakeMiddleware = () => (next) => (action) => {
  if (action.type === LOGOUT) {
    localStorage.removeItem(NOT_SURE_ANSWERED_QUESTIONS_STORAGE_KEY);
  }

  return next(action);
};
